import vxxData from "../kits/data.js";
import { Dialog } from "vant";
import { Toast } from "vant";
import axios from "axios";
import md5 from "blueimp-md5";
import TFWebLog from 'tf_web_log'
import store from "../store/index.js";


export var app_Id = null

var tfWebLog = TFWebLog.getInstance()
export default {
  getQueryDsId,
  getQueryChannelId,
  getQueryString,
  getQueryString2,
  baseUrl,
  baseUrl1,
  baseUrl2,
  baseUrl3,
  tencentOssUrl,
  aliOssUrl,
  baseUrlUser,
  baseUrlSchool,
  changeTime,
  setCookie,
  getCookie,
  delCookie,
  two,
  isWeixin,
  encrypt,
  getDsInfo,
  getCache,
  clearAllCookie,
  imgPath,
  login,
  checkPhoneType,
  bugTicket,
  getCoupon,
  weixinPay,
  DrawingCanvas,
  getIsDeveloper,
  updateOnlineStatus,
  getFakeLiveInfo,
  getQueryData,
  getUrlAddQuery,
  getDs_id,
  setDs_id,
  clearFansInfo,
  getCommentTimes,
  LoginJumpQQ,
  LoginJumpWx,
  getUserInfoReloadByToken,
  getCacheUserInfo,
  Weixin,
  baseUrlUserBak,
  isWeixinMP,
  isWeixinMPInPC,
  guid,
  setAppID,
  baseUrlShanhuLive,
  getShanhuConfig,
  copyText,
  scfURL
};

axios.interceptors.response.use(response=>{
  console.log('success')
  return response
},err=>{
  console.log('fail')
})
var that = this;
var developer; //是否在开发者环境
var fans_id = "";
var userSig;
var tokenStr;
var agreement = 'https://'

var globalDirectSeeding = {} 

function getIsDeveloper() {
  return developer;
}

if (process.env.NODE_ENV == 'production') {
  developer = false;
  agreement = 'https://'
  // 取消日志打印
  // console.log = function() {};
} else {
  console.log("当前在测试环境");
  developer = false;
}
// developer = true;
function scfURL () {
	let scf_url = "";
	if (developer) {
		scf_url = "https://service-jmibg8h4-1317978474.gz.apigw.tencentcs.com/release";
	} else {
		scf_url = "https://scf.wanzibook.com";
	}
	return scf_url;
}


function imgPath() {
  if (developer) {
    return "../../../statics/imgs/";
  } else {
    return agreement + "res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/";
  }
}

function baseUrl() {
  var baseUrl;
  if (developer) {
    baseUrl = agreement + "liveapi.tenghuiwangxiao.cn";
  } else {
    baseUrl = agreement + "liveapi.tenghuiwangxiao.cn";
  }
  return baseUrl;
}

function baseUrl1() {
	if(developer){
		// return agreement + "liveapi2.tenghuiwangxiao.cn";
    return agreement + "live.tenghuiketang.com/liveapi";
	}else{
		return agreement + "liveapi2.tenghuiwangxiao.cn";
	}
}

function baseUrl2() {
	if(developer){
		// return agreement + "liveapi2.tenghuiwangxiao.cn/api";
    return agreement + "live.tenghuiketang.com/liveapi/api";
	}else{
		return agreement + "liveapi2.tenghuiwangxiao.cn/api";
	}
}

function baseUrl3() {
	if(developer){
		// return agreement + "liveapi2.tenghuiwangxiao.cn/wap";
    return agreement + "live.tenghuiketang.com/liveapi/wap";
	}else{
		return agreement + "liveapi2.tenghuiwangxiao.cn/wap";
	}
}

function baseUrlUser() {
	if(developer){
		// return  agreement + "user-data.tenghuiwangxiao.cn";
    return  agreement + "data.tenghuiketang.com";
	}else{
		return  agreement + "user-data.tenghuiwangxiao.cn";
	}
}

function baseUrlUserBak() {
	if(developer){
		// return  agreement + "user-data.tengface.com";
    return  agreement + "data.tenghuiketang.com/dataapi";
	}else{
		return  agreement + "user-data.tengface.com";
	}
}

function baseUrlSchool() {
	if(developer){
		// return  agreement + "online.tenghuiwangxiao.cn";
    return  agreement + "online.tenghuiketang.com";
	}else{
		return  agreement + "online.tenghuiwangxiao.cn";
	}
}

function baseUrlShanhuLive() {
  if(developer){
		return  agreement + "live.tenghuiketang.com";
	}else{
		return  agreement + "live.shkt.online";
	}
}

function tencentOssUrl() {
	return 'https://tengface-live-user-1308721187.cos.accelerate.myqcloud.com'
}

function aliOssUrl() {
	return 'https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com'
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function getQueryDsId(){
	var ds_id = getQueryString('ds_id')
	var d = getQueryString('d')
	if(ds_id){
		return ds_id;
	}
	if(d){
		return d;
	}
	return null;
}

function getQueryChannelId(){
	var channel_id = getQueryString('channel_id')
	var c = getQueryString('c')
	if(channel_id){
		return channel_id;
	}
	if(c){
		return c;
	}
	return null;
}

function getQueryString2(urlStr, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  if (urlStr.indexOf("?") != -1) {
    urlStr = "?" + urlStr.substr(urlStr.indexOf("?") + 1);
    var r = urlStr.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
  }
  return null;
}

function setCookie(name, value, Days) {
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
}

function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}

function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; )
      document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
  }
}

function changeTime(time) {
  if (time && parseInt(time).toString() != "NaN") {
    var h = parseInt(time / 3600);
    var m = parseInt((time % 3600) / 60);
    var s = parseInt(time % 60);
    return two(h) + ":" + two(m) + ":" + two(s);
  } else {
    return "00:00:00";
  }
}

function two(num) {
  if (num < 10) {
    return "0" + num;
  }
  return num;
}

function isWeixin() {
  var agent = navigator.userAgent.toLowerCase();
  if (agent.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

function is_qq(){
  var sUserAgent =navigator.userAgent.toLowerCase();
  if( sUserAgent.match(/QQ/i) == 'qq'){
    return true
  }else{
    return false
  }
}

//小程序
function isWeixinMP() {
  var agent = navigator.userAgent.toLowerCase();
  if (agent.match(/miniprogram/i) == "miniprogram") {
    return true;
  } else {
    return false;
  }
}

function isWeixinMPInPC() {
  var agent = navigator.userAgent.toLowerCase();
  if (agent.match(/miniprogram/i) == "miniprogram" && agent.match(/windowswechat/i) == "windowswechat") {
    return true;
  } else {
    return false;
  }
}

function encrypt(option) {
  var Base64 = require("js-base64").Base64;
  var verifyCode = vxxData.verifyCode;
  console.log(verifyCode);
  var tmp;
  var tmp1;

  var data1 = JSON.stringify(option);
  var params1 = Base64.encode(data1).replace(/\+/g, "%2B");
  var newstr1 = "";
  var tmp2 = params1.substring(0, 3);
  var tmp3 = params1.substring(3, params1.length);
  newstr1 += tmp2 + md5(data1 + verifyCode) + tmp3;
  newstr1 = "data=" + newstr1;
  return newstr1;
}

function setDs_id(new_ds_id){
	ds_id = new_ds_id;
}

function getDs_id(){
	return ds_id
}

function setAppID(app_id) {
   app_Id = app_id
}

var ds_id = getQueryString("ds_id");
var nick;
var userSig;
var loginCode;
var Weixin = isWeixin();
var fans = {};

function login(liveapp_id,liveapp_uid,callback, title) {
  initLoginGetAppId(
    liveapp_id,
    function(appidTmp) {
      var isCache = getCache(appidTmp);
      if (isCache) {
        //有缓存
        callback(fans);
      } else {
        //没有缓冲
        if (!Weixin) { //qq登录
            app_Id = "102004807";
            var isCache = getCache(app_Id);
            if (isCache) {
              //有缓存
              callback(fans);
            } else {
              //没有缓冲
              //先判断code是否存在
              loginCode = getQueryString("code");
              if (!loginCode) {
                //不存在,获取code
              if (is_qq()) {//qq内
                initLoginJumpQQ(app_Id, title);
              } else {
                callback({showQQPopUp:true});
                }
              } else {//有code
                let loginType = getQueryString("loginType");
                if (loginType == 'wx') {
                    getFansInfo('wx',callback, title);
                }else {
                   getFansInfo('qq',callback, title);
                }
              }
            }
        }else{ //微信
            loginCode = getQueryString("code");
            if (!loginCode) {
              callback({showWxPopUp:true});
              //不存在,获取code
              // initLoginJumpWx(appidTmp);
            } else {
              let loginType = getQueryString("loginType");
             if (loginType == "cloudapi" && window.isExceptionMode) {
                 getFansInfoCloudApi(liveapp_uid,callback)
              }else{
                 getFansInfo('wx',callback, title);
              }
            }
        }
      }
    },
    function() {
      callback({});
    }
  );
}

function LoginJumpQQ(title){
  initLoginJumpQQ(app_Id, title);
}

function LoginJumpWx(title){
  initLoginJumpWx(app_Id, window.isExceptionMode? 'cloudapi':'', title)
}

//获取用户数据缓存
function getCache(appIdTmp) {
  //判断缓存是否存在
  try {
    fans = JSON.parse(localStorage.getItem(appIdTmp));
    if (fans && fans.unReal != 1 && (fans.openid || fans.isTokenLogin || is_qq())) { //不是虚拟用户
      //适配其他的应用
      setCookie("fans_id", fans.fans_id);
      fans_id = fans.fans_id;
      userSig = fans.userSig;
      nick = fans.nick;
      tokenStr = fans.token;
      return true;
    }
    clearFansInfo()
  } catch (e) {
    clearFansInfo();
    return false;
  }
  
  return false;
}

function getCacheUserInfo(appIdTmp){
  try {
    fans = JSON.parse(localStorage.getItem(appIdTmp));
    if (fans) {
      //适配其他的应用
      setCookie("fans_id", fans.fans_id);
      fans_id = fans.fans_id;
      userSig = fans.userSig;
      nick = fans.nick;
      tokenStr = fans.token;
      return fans;
    }else{
      return null;
    }
  } catch (e) {
     return null;
  }
} 

function clearFansInfo() {
   if (app_Id) {
      localStorage.removeItem(app_Id);
      delCookie('fans_id')  
   }
}

//获取动态参数
function getFansInfo(type,callback, title) {
  const extraAppId = getQueryString("appId")
  var loginUrl = baseUrl2() + "/user/login/autoLogin/?code=" + loginCode + "&ds_id=" + ds_id;
  if(extraAppId) {
    // 如果有额外的appId参数，表示当前登录的公众号不是系统等级或者自定义里面的公众号，是针对进不去的学员（港澳台或国外）
    // 开发人员手动拼接的登录链接，需要传这个公众号的AppId和一个flag字段，表示这是一个自定义公众号登录
    loginUrl = `${loginUrl}&appid=${extraAppId}&flag=1`
  }
  console.log(loginUrl);
   
  if (type == "qq") {
      loginUrl =  baseUrl2() + "/user/login/qqLogin?code=" + loginCode + "&ds_id=" + ds_id;
  }

  axios
    .get(loginUrl,{timeout: 2000})
    .then(function(data) {
      if (data.data.code == 200) {
        var data = data.data.data;
        //这里需要缓存数据,然后重新加载
        fans = {
          fans_id: data.fans_id,
          header: data.header,
          nick: data.nick,
          userSig: data.tsl_sig,
          real_auth: data.real_auth,
          status: data.status,
          token: data.token,
          openid:data.openid
        };
        //适配其他的应用
        setCookie("fans_id", data.fans_id);
        if (app_Id) {
          localStorage.setItem("current_app_Id",app_Id);
          localStorage.setItem(app_Id, JSON.stringify(fans));
        }
        callback(fans);
      } else if (data.data.code == 400) { 
        if (data.data.message == '直播间不存在!') {
          Toast({message:data.data.message, duration:0})
        }else {
          if (type == "qq") {
            initLoginJumpQQ(app_Id, title);
          }else{
            if (!isWeixin() && !isWeixinMP()) { //qq登录
              location.href = deleteUrlParam('code')
            }else {
              initLoginJumpWx(app_Id);
            }
          }
        }
      }
    })
    .catch(function(data) {
      // Toast("网络错误！");
      console.log(JSON.stringify(data));
      if (type == 'wx') {
        initLoginJumpWx(app_Id,'cloudapi');
      }else{
        callback({});
      }
      
    });
}

function createCode() {
  var demo=""
  //这里取的是4位，所以for循环4次，如果是6位数字验证码则为6
  for(var i=0;i<6;i++){
    //设置随机数范围,这设置为0 ~ 9
    var a = Math.floor(Math.random() * 9);
    a = (a == 0 ? 1:a);
    //拼接字符串
    demo += a
  }
  return demo;
}

function getFansInfoCloudApi(liveapp_uid,callback) {
  var loginUrl = `${scfURL()}/api/login/getUserInfo`;
  // let params = `code=${loginCode}`
  let app_IdTMp = store.state.setting.defaultConfig.official_account_appid
  console.log(loginUrl);
    let params = `code=${loginCode}&uid=${liveapp_uid}&ds_id=${ds_id}`
    axios.post(loginUrl,params,{timeout: 5000}).then(function(data) {
        console.log("getFansInfoCloudApi====>",data)
        if (data.data.code == 200) {
          var data = data.data.data;
          console.log("getFansInfoCloudApi2====>",data)
          registerUserInfo(liveapp_uid,data,callback)
        }else if (data.data.code == 400) {
          initLoginJumpWx(app_Id,'cloudapi');
        }
      }).catch(function(data) {
        // Toast("网络错误！");
        console.log("网络错误！",data)
        // console.log(JSON.stringify(data));
        let fansInfoTMp = getCacheUserInfo(app_Id)
        if (fansInfoTMp) {//用缓存用户信息
          callback(fansInfoTMp);
        }else { //随机用户信息
         let fansIdTmp = createCode();
         let fans = {
            fans_id: fansIdTmp,
            header: "https://tengface-live.oss-cn-beijing.aliyuncs.com/admin/img/youke_header.png",
            nick: `用户_${fansIdTmp}`,
            userSig: "",
            token:"",
            unReal:1
          };
          //适配其他的应用
          setCookie("fans_id", data.fans_id);
          if (app_Id) {
            localStorage.setItem("current_app_Id",app_Id);
            localStorage.setItem(app_Id, JSON.stringify(fans));
          }
          callback(fans);
        } 
      });
}

//注册用户信息
function registerUserInfo(liveapp_uid,userInfo,callBack) {
  
  // let params = `nick=${userInfo.nickname}&uid=${liveapp_uid}&openid=${userInfo.openid}&header=${userInfo.headimgurl}`
  // axios.post(baseUrl2()+"/user/login/register",params)
  // .then(function(response) {
  //   // if(response.data.code == 200){
  //   //   var data = response.data.data;
  //   //     fans = {
  //   //       fans_id: data.fans_id,
  //   //       header: data.header,
  //   //       nick: data.nick,
  //   //       userSig: data.tsl_sig,
  //   //       real_auth: data.real_auth,
  //   //       status: data.status,
  //   //       token: data.token,
  //   //       openid:userInfo.openid
  //   //     };
  //   //     //适配其他的应用
  //   //     setCookie("fans_id", data.fans_id);
  //   //     if (app_Id) {
  //   //       localStorage.setItem("current_app_Id",app_Id);
  //   //       localStorage.setItem(app_Id, JSON.stringify(fans));
  //   //     }
  //   //     callBack(fans);
  //   // }else{
  //       fans = {
  //         fans_id: userInfo.fans_id,
  //         header: userInfo.headimgurl,
  //         nick: userInfo.nickname,
  //         userSig: userInfo.tsl_sig,
  //         real_auth: userInfo.real_auth,
  //         status: userInfo.status,
  //         token: userInfo.token,
  //         // unReal:1,
  //         openid: userInfo.openid,
  //         is_exception_mode:true
  //       };
  //       //适配其他的应用
  //       setCookie("fans_id", userInfo.fans_id);
  //       if (app_Id) {
  //         localStorage.setItem("current_app_Id",app_Id);
  //         localStorage.setItem(app_Id, JSON.stringify(fans));
  //       }
  //       callBack(fans);
  //   // }
  // })
  // .catch(function(error) {
    //这里需要缓存数据,然后重新加载
       let fans = {
          fans_id: userInfo.fans_id,
          header: userInfo.headimgurl,
          nick: userInfo.nickname,
          userSig: userInfo.tsl_sig,
          status: userInfo.status,
          real_auth: userInfo.real_auth,
          token: userInfo.token,
          openid: userInfo.openid,
          is_exception_mode:true
        };
        //适配其他的应用
        setCookie("fans_id", userInfo.fans_id);
        if (app_Id) {
          localStorage.setItem("current_app_Id",app_Id);
          localStorage.setItem(app_Id, JSON.stringify(fans));
        }
        callBack(fans);
  // });

  
}

// 获取伪直播信息
function getFakeLiveInfo(tid,callback){
  axios
  .post(baseUrl3() + "/live/getLiveInfoById", "tid=" + tid)
  .then(function(response) {
    if(response.data.code == 200){
      callback(true,response.data.data);
    }else{
      callback(false,response);
    }
  })
  .catch(function(error) {
    callback(false,error);
  });
}


function mergeDsData(fakeInfo,dsInfo){
  var newInfo = {...dsInfo};
  newInfo.direct_seeding.room_id = fakeInfo.room_id;
  newInfo.direct_seeding.name = fakeInfo.name;
  newInfo.direct_seeding.real_start_time = fakeInfo.start_time_real;
  newInfo.direct_seeding.real_end_time = fakeInfo.end_time_real;
  newInfo.direct_seeding.start_time = fakeInfo.start_time;
  newInfo.fakeLive = true;
  newInfo.fakeTemplateId = fakeInfo.t_id;
  newInfo.direct_seeding.break_point = [];
  if(fakeInfo.status == '1'){
    newInfo.direct_seeding.direct_status = 'not_started';
    newInfo.box_info = {};
  }else if(fakeInfo.status == '2'){
    newInfo.direct_seeding.direct_status = 'running';
    newInfo.box_info = {
      pull_stream_url:JSON.stringify({
        flv_url:fakeInfo.play_url_flv,
        m3u8_url:fakeInfo.play_url_m3u8,
        play_url_web_rtc:fakeInfo.play_url_web_rtc
      })
    };
  }else if(fakeInfo.status == '3'){
    newInfo.direct_seeding.direct_status = 'end';
    newInfo.box_info = {};
  }

  return newInfo;
}

//新版获取直播间信息方法
function getDsInfo(callback,fakeInfo) {
   const tencentOssUrl = `https://tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com/ds/larave_cache/dsCache_${ds_id}.json?${new Date().getTime()}${parseInt(Math.random()*10e4)}`
   const use_time_b = new Date()
   axios.get(tencentOssUrl,{timeout:2000}).then(data=>{
    let use_time = new Date() - use_time_b;
    tfWebLog.putLogs(10000,1,{responseData:data,use_time:use_time});
    getDsInfoSuccess(data,callback,fakeInfo)
  }).catch((error)=> {
    let use_time = new Date() - use_time_b;
    let message = (error && error.message)?error.message:error
    tfWebLog.putLogs(10000,1,{responseData:message,use_time:use_time});
    //发生错误时执行的代码
    console.log("获取初始化数据失败了");
    getDsInfoRequest(callback,fakeInfo);
  })
}

const getDsInfoSuccess = (data,callback,fakeInfo)=>{
  if (data.data) {
    if(fakeInfo){
      data.data = mergeDsData(fakeInfo,data.data);
    }
    store.dispatch('dsInfo/getDsInfo',data.data)
    vxxData.setInitData(data.data);
    if (data.data.direct_seeding) {
      globalDirectSeeding =  data.data.direct_seeding
      document.title = data.data.direct_seeding.name;
      document.getElementById("description").content =
        data.data.direct_seeding.desc;
    }
    app_Id = data.data.direct_seeding.appid;
    getUserInfoByToken(data.data,()=>{
      callback(data.data);
    });
  } else {
    getDsInfoRequest(callback,fakeInfo);
  }
}




function getDsInfoRequest(callback,fakeInfo) {
  axios
    .post(baseUrl2() + "/init/index/index", "ds_id=" + ds_id)
    .then(function(response) {
      console.log(response);
      var data = response.data;
      if (data.code == 200) {
        if(fakeInfo){
          data.data = mergeDsData(fakeInfo,data.data);
        }
        vxxData.setInitData(data.data);
        document.title = data.data.direct_seeding.name;
        document.getElementById("description").content =
          data.data.direct_seeding.desc;
        app_Id = data.data.direct_seeding.appid;
        getUserInfoByToken(data.data,()=>{
          callback(data.data);
        });
      } else if (data.code == 400) {
        Toast({message:data.message, duration:0})
      } else {
        console.log("init/index/index调用接口失败了200");
      }
    })
    .catch(function(error) {
      console.log("init/index/index调用接口失败了" + error);
    });
}

function initLoginGetAppId(liveapp_id, callback, errorCallBack) {
  if (liveapp_id) {
    app_Id = liveapp_id;
    localStorage.setItem("current_app_Id", liveapp_id);
    callback(liveapp_id);
  } else {
    axios
      .post(baseUrl2() + "/init/getDsInfo", "ds_id=" + ds_id)
      .then(function(response) {
        var data = response.data;
        if (data.code == 200) {
          app_Id = data.data;
          //获取当前的appid
          console.log("获取当前的appid:" + app_Id);
          localStorage.setItem("current_app_Id", data.data);
          callback(data.data);
        } else {
          Toast(data.message);
          console.log("/init/getDsInfo调用接口失败了else");
        }
      })
      .catch(function(error) {
        console.log(JSON.stringify(error));
        errorCallBack();
        Toast("网络错误！");
        console.log("/init/getDsInfo调用接口失败了" + error);
      });
  }
}

// 获取到了token更新用户信息
function getUserInfoReloadByToken(token){
  if(token){
    const user = { token };
    localStorage.setItem(app_Id,JSON.stringify(user));
    axios.post(baseUrl2() + "/user/getUserInfoByToken", "").then((res)=>{
      if(res.data.code == 200){
        var userInfo = res.data.data;
        fans = {
          fans_id: userInfo.fans_id,
          header: userInfo.header,
          nick: userInfo.nick,
          userSig: userInfo.tsl_sig,
          real_auth: userInfo.real_auth,
          status: userInfo.status,
          isTokenLogin:1,
          token: userInfo.token,
        };
        //适配其他的应用
        setCookie("fans_id", userInfo.fans_id);
        if (app_Id) {
          localStorage.setItem("current_app_Id",app_Id);
          localStorage.setItem(app_Id, JSON.stringify(fans));
        }
        window.location.reload();
      }
    }).catch((error)=>{
      console.error("getUserInfoByToken",error);
    });
  }else{
    console.error("getUserInfoReloadByToken","token不存在");
  }
}

//获取珊瑚配置文件
function getShanhuConfig(uid,callBack){
  axios.get('https://shkt-online-live-1317978474.cos.accelerate.myqcloud.com/web/config/miniConfig.json?a='+new Date().valueOf()).then(data=>{
      let miniConfig = data.data || {}
      console.log("miniConfig==",miniConfig)
      axios.get(`https://shkt-online-live-1317978474.cos.accelerate.myqcloud.com/web/config/userConfig/${uid}.json?a=${new Date().valueOf()}`).then((res)=>{
        callBack(Object.assign(miniConfig,res.data || {}))
      }).catch((error)=>{
        callBack(miniConfig)
      });
  }).catch((error)=> {
    callBack({wx_h5_url:'https://u.shanhuclass.cn'})
  })
}


// 用token获取用户信息
function getUserInfoByToken(dsInfo,callBack){
  var token = getQueryString("token");
  var otherLogin = getQueryString('other');
  var shool_token = getQueryString('shool_token');
  //  测试环境也可以 和  iOS safair浏览器下有效 而且不在微信环境
  if(token){
    if((isIhponeSafari() && !isWeixin()) || developer || otherLogin){

      if (dsInfo.direct_seeding.is_shanhu == 2) { //珊瑚跳转
        const user = { token };
        localStorage.setItem(app_Id,JSON.stringify(user));
        axios.post(baseUrl2() + "/user/login/getShToken","").then((res)=>{
          if(res.data.code == 200){
            var shToken = res.data.data.shToken;
            if (app_Id) {
              localStorage.removeItem(app_Id)
            }
            getShanhuConfig(dsInfo.direct_seeding.uid,(config)=>{
              location.href = `${config.wx_h5_url}/?ds_id=${ds_id}&token=${shToken}&other=${otherLogin}&shool_token=${shool_token}`;
            })
            return
          }
           clearToken();
          if(callBack){
            callBack();
          }
        }).catch((error)=>{
             clearToken();
            if(callBack){
              callBack();
            }
        });
        
      }else {
        if (shool_token) {
          setCookie("netschool_token",shool_token, 30);
        }
        const user = { token };
        localStorage.setItem(app_Id,JSON.stringify(user));
        axios.post(baseUrl2() + "/user/getUserInfoByToken", "").then((res)=>{
          if(res.data.code == 200){
            var userInfo = res.data.data;
            fans = {
              fans_id: userInfo.fans_id,
              header: userInfo.header,
              nick: userInfo.nick,
              userSig: userInfo.tsl_sig,
              real_auth: userInfo.real_auth,
              status: userInfo.status,
              token: userInfo.token,
              isTokenLogin:1
            };
            //适配其他的应用
            setCookie("fans_id", userInfo.fans_id);
            setCookie("user_token",userInfo.token, 30);
            if (app_Id) {
              localStorage.setItem(app_Id, JSON.stringify(fans));
            }
            clearToken();
          }
          if(callBack){
            callBack();
          }
        }).catch((error)=>{
          console.error("getUserInfoByToken",error);
          clearToken();
          if(callBack){
            callBack();
          }
        });
      }
      
      return;
    }
    if(callBack){
      callBack();
    }
  }else{
    if(callBack){
      callBack();
    }
  }
}

function isIhponeSafari(){
  var ua = navigator.userAgent.toLowerCase();
  //判断是不是在iPhone的Safair浏览器打开的本页面
  if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
      ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
      ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
      console.log("是safari");
      return true
  }
  else {
      console.log("不是safari");
      return false
  }
}

function getQueryData(url) {
  var urlAll = url;
  var tmp = urlAll.split("#")[0];
  tmp = tmp.split("?");
  if (tmp.length == 1) {
      return {};
  }
  var list = tmp[1].split("&");
  console.log(list);
  var data = {};
  for (let index = 0; index < list.length; index++) {
      var element = list[index];
      var arr = element.split('=');
      if (arr.length >= 2) {
          data[arr[0]] = element.substring(arr[0].length + 1);
      }
  }
  return data;
}


function getUrlAddQuery (url, data) {
  var isFrist = true
  for (const key in data) {
    var value = data[key]
    if (value === '') {
      continue
    }
    if (isFrist) {
      isFrist = false
      url = url + '?'
      url = url + key + '=' + value
    } else {
      url = url + '&' + key + '=' + value
    }
  }
  return url
}

function clearToken(){
  var data = getQueryData(window.location.href);
  data.token = '';
  data.shool_token = '';
  if(checkPhoneType() == 2){
    var url = getUrlAddQuery(window.location.pathname,data);
    window.history.replaceState({}, "除去URL参数", url);
    window.location.href = url;
  }else{
    var url = getUrlAddQuery(window.location.protocol + "//" + window.location.host + window.location.pathname,data);
    window.location.href = url;
  }
}

function deleteUrlParam(param,param1,keyValue) {
  const url = window.location.href
  const parsedUrl = new URL(url)
  parsedUrl.searchParams.delete(param)
  parsedUrl.searchParams.delete(param1)
  //添加参数
  if (keyValue) {
    Object.keys(keyValue).forEach(key => {
      parsedUrl.searchParams.set(key, keyValue[key])
    })
  }
  return parsedUrl.toString()
}


/**
* 获取微信授权登录的公众号appid和授权域名
* 优先级一. 如果链接带了公众号appid和授权域名，则优先使用链接的参数
* 优先级二. 如果是在小程序环境并且开启了小程序独立公众号配置，则优先使用小程序独立公众号配置
* 优先级三. 其他情况读取机构域名配置
*/
async function getAuthInfo() {
  let res
  try {
    res = await axios.get(`https://tengfaceliveuser.tengface.net/web/config/miniConfig.json?ran=${new Date().valueOf()}`)
  } catch (error) {
    console.error('getAuthInfo error: ', res)
  } finally {
    if(isWeixinMP() && res.data.open_wechat_mini_separate_auth === 1) {

      if (!(store.state.setting.defaultConfig.is_config_official_account == 2 && store.state.setting.defaultConfig.is_wx_auth_mp == 1)) {
           return {
            flag: 1,
            appId: res.data.wechat_mini_separate_account,
            authUrl: res.data.wechat_mini_separate_auth_url
          }
      }

    } else {
      const extraAppId = getQueryString("appId")
      const extraAuthDomian = getQueryString("authDomain")
      // 判断url是否带了公众号appid和授权域名
      if(extraAppId && extraAuthDomian) {
        return {
          flag: 1,
          appId: extraAppId,
          authUrl: extraAuthDomian
        }
      }
    }
    return {
      appId: store.state.setting.defaultConfig.official_account_appid,
      authUrl: store.state.setting.defaultConfig.wechat_auth_domain
    }
  }
}

async function initLoginJumpWx(appid,loginType,liveTitle) {
  var redirect_uri = deleteUrlParam('code','loginType')
  if (loginType == "cloudapi" && redirect_uri.indexOf("loginType") == -1) {
     redirect_uri = deleteUrlParam('code','loginType',{loginType:'cloudapi'})
  }
  const uId = store.state.setting.uId
  const browserType = isWeixinMP() ? 2 : 1
  const redirectUrl =  encodeURIComponent(redirect_uri)
  const { flag, authUrl, appId } = await getAuthInfo()
  window.location.href = `${authUrl}/login/#/wx-login?appId=${appId}&flag=${flag}&browserType=${browserType}&uId=${uId}&redirectUrl=${redirectUrl}&title=登录&origin=tengface`

  // // window.location.href =
  // //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
  // //   appid +
  // //   "&redirect_uri=" +
  // //   encodeURIComponent(redirect_uri) +
  // //   "&response_type=code&scope=snsapi_userinfo&state=STATE";
  // const redirectUrl =  encodeURIComponent(redirect_uri)
  // // if (globalDirectSeeding && globalDirectSeeding.is_customize_domain == 2 && globalDirectSeeding.is_config_official_account == 2) {
  // //   window.location.href = `${location.origin}/login/#/wx-login?appId=${appid}&redirectUrl=${redirectUrl}&title=${liveTitle}&origin=tengface`
  // // }else {
  //   // window.location.href = `https://login1.bbxiuc.cn/login/#/wx-login?appId=${appid}&redirectUrl=${redirectUrl}&title=${liveTitle}&origin=tengface`
  // const uId = store.state.setting.uId
  // let  browserType = 1 // 1:微信h5 2:微信小程序 
  // //判断是否是小程序环境
  // if (isWeixinMP()) { //小程序内
  //     browserType = 2
  // }
  // const { wechat_auth_domain, official_account_appid } = store.state.setting.defaultConfig
  // window.location.href = `${wechat_auth_domain}/login/#/wx-login?appId=${official_account_appid}&browserType=${browserType}&uId=${uId}&redirectUrl=${redirectUrl}&title=${liveTitle}&origin=tengface`
  // // }
}

function initLoginJumpQQ(appid, liveTitle) {
  // var redirect_uri = "https://"+window.location.host+"/index.html"+window.location.search;
  // redirect_uri = redirect_uri.split("&code")[0];
  // alert(redirect_uri)
  // window.location.href =
  //   "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=" +
  //   appid +
  //   "&redirect_uri=" +
  //   encodeURIComponent(redirect_uri) +
  //   "&state=qq&origin=tengface";
  var redirect_uri = window.location.href;
  redirect_uri = redirect_uri.split("&code")[0];
  const uId = store.state.setting.uId
  const redirectUrl =  encodeURIComponent(redirect_uri)
  const { qq_auth_domain, official_account_appid } = store.state.setting.defaultConfig
  // window.location.href = `https://login.bbxiuc.cn/login/#/qq-login?appId=${appid}&redirectUrl=${redirectUrl}&title=${liveTitle}&origin=tengface`
  window.location.href = `${qq_auth_domain}/login/#/qq-login?appId=${official_account_appid}&uId=${uId}&redirectUrl=${redirectUrl}&title=${liveTitle}&origin=tengface`
}

function checkPhoneType() {
  var u = navigator.userAgent;
  // 1是安卓机	2 是苹果机	3 未知机型 4 winphone
  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    //安卓手机
    return 1;
  } else if (u.indexOf("iPhone") > -1) {
    //苹果手机
    // window.location.href = "mobile/index.html";
    return 2;
  } else if (u.indexOf("Windows Phone") > -1) {
    //winphone手机
    return 4;
  } else {
    return 3;
  }
}

function bugTicket(id, callback) {
  var that = this;
  axios
    .post(
      baseUrl3() + "/ticket/order",
      "ds_id=" + ds_id + "&fans_id=" + fans_id + "&coupon_id=" + id
    )
    .then(function(data) {
      if (data.data.code == "200") {
        weixinPay(data.data.data, callback);
      } else if (data.data.code == "2000") {
        Toast("抵扣成功");
        callback();
      } else {
        Toast("购买门票失败！");
      }
    })
    .catch(function(res) {
      Toast("购买门票失败！");
    });
}

function weixinPay(p, callback) {
  var that = this;
  console.log(p);

  WeixinJSBridge.invoke(
    "getBrandWCPayRequest",
    {
      appId: p.appId, //公众号名称，由商户传入
      timeStamp: String(p.timeStamp), //时间戳，自1970年以来的秒数
      nonceStr: p.nonceStr, //随机串
      package: p.package,
      signType: p.signType, //微信签名方式：
      paySign: p.paySign, //微信签名
    },
    function(res) {
      // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回		ok，但并不保证它绝对可靠。
      if (
        res.errMsg == "get_brand_wcpay_request:ok" ||
        res.err_msg == "get_brand_wcpay_request:ok"
      ) {
        Toast("门票购买成功");
        callback();
      }
    }
  );
}

function getCoupon(callback) {
  var that = this;
  axios
    .post(
      baseUrl3() + "/ticket/get_coupon",
      "ds_id=" + ds_id + "&fans_id=" + fans_id
    )
    .then(function(data) {
      var data = data.data;
      if (data.code == 200) {
        console.log(data.data);
        callback(data.data);
      }
    })
    .catch(function(data) {
      console.log("错误" + data);
    });
}

function DrawingCanvas(image) {
  // 创建canvas DOM元素，并设置其宽高和图片一样
  var canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
  canvas.getContext("2d").drawImage(image, 0, 0);
  return canvas;
}

function updateOnlineStatus(ds_id, fans_id, is_live) {
  var params = "ds_id=" + ds_id + "&fans_id=" + fans_id + "&is_live=" + is_live;

  axios
    .post(baseUrl() + "/statistics/analysis/updateOnlineStatus", params)
    .then(function(response) {
      console.log(response);
      var data = response.data;
      if (data.code == 200) {
        console.log("updateOnlineStatus1");
      } else {
        console.log("updateOnlineStatus2");
      }
    })
    .catch(function(error) {
      console.log("updateOnlineStatus3" + error);
    });
}

function getCommentTimes(timeStr) {
  var time = new Date();
  if (timeStr) {
    time = new Date(timeStr);
  }
  var year = time.getFullYear();
  var month = two(time.getMonth() + 1);
  var date = two(time.getDate());
  var hours = two(time.getHours());
  var minutes = two(time.getMinutes());
  var seconds = two(time.getSeconds());

  return (
    year +
    "-" +
    month +
    "-" +
    date +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds
  );
}

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    // navigator.clipboard.writeText(text).then(() => {
    //   Toast("复制成功");
    // }).catch((err) => {
    //   console.error("复制失败", err);
    // });
    navigator.clipboard.writeText(text);
  } else {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
  }
  Toast("复制成功");
}